import { useState } from 'react'
import MediaFooter from './MediaFooter'
import VideoPreview from './VideoPreview'
import EmptyState from './EmptyState'
import Header from './Header'

const Video = ({ video, setPlayingVideo }) => {
    return (
        <div className="position-relative">
            <video
                controls
                autoPlay
                style={{ width: '100%', height: 'auto', borderRadius: '8px' }}
                onEnded={() => setPlayingVideo(null)}
            >
                <source src={video.url} type="video/mp4" />
                Your browser does not support the video tag.
            </video>
        </div>
    )
}

const VideoLibrary = ({ videos, search, selectedVideos, handleVideoSelectionToggle, showHeader, adAssets }) => {
    const [playingVideo, setPlayingVideo] = useState(null)

    const calculateSrcSet = (video) => {
        return video.thumbnails.map((thumbnail) => `${thumbnail.url} ${thumbnail.width}w`).join(', ')
    }

    const handleVideoClick = (video) => {
        if (playingVideo?.id === video.id) return

        setPlayingVideo(video)
    }

    const videosToDisplay = videos.filter((video) =>
        String(video.name || '')
            .toLowerCase()
            .includes(search.toLowerCase()),
    )
    const isUploaded = (id) => adAssets.some((asset) => asset.source_id == id && asset.source === 'meta')

    return (
        <div>
            {showHeader && <Header title="Videos" />}
            <div>
                {videosToDisplay.length === 0 ? (
                    <EmptyState type="videos" />
                ) : (
                    <div className="d-flex flex-wrap gap-3">
                        {videosToDisplay.map((video) => (
                            <div key={video.id} className="position-relative" style={{ width: '200px' }}>
                                {playingVideo?.id === video.id ? (
                                    <Video video={video} setPlayingVideo={setPlayingVideo} />
                                ) : (
                                    <VideoPreview
                                        video={video}
                                        calculateSrcSet={calculateSrcSet}
                                        handleVideoClick={handleVideoClick}
                                    />
                                )}
                                <MediaFooter
                                    id={video.id}
                                    name={video.name}
                                    handleSelectionToggle={handleVideoSelectionToggle}
                                    selected={selectedVideos.includes(video.id) || isUploaded(video.id)}
                                />
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    )
}

export default VideoLibrary
